import { render } from "./UnNftAvatar.vue?vue&type=template&id=5dc8d6e3"
import script from "./UnNftAvatar.vue?vue&type=script&lang=js"
export * from "./UnNftAvatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__